@if (vm$ | async; as vm) {
  <div class="flex justify-center items-center" id="catalog_result-list_wrp_toolbar">
    <div class="flex items-center">
      <span class="ml-2 mr-2" id="catalog_result-list_txt_page-label">{{ label }}</span>
      <cat-result-list-mode-toolbar
        (changeMode)="onChangeResultListMode($event)"
        [enabled]="resultListModeEnabled"
        [resultListMode]="vm.resultListMode"
        [resultListModes]="resultListModes"
        class="hidden md:block"
      ></cat-result-list-mode-toolbar>
      <div class="border-left ml-2 pl-2">
        <button
          (click)="onSort()"
          [ngClass]="{'text-primary': isSortDefault}"
          [title]="'catalog.result_list.open_sort' | transloco"
          id="catalog_result-list_btn_open-sort-dialog"
          mat-icon-button
        >
          <mat-icon>sort_by_alpha</mat-icon>
        </button>
      </div>
    </div>
    <cat-result-list-paginator
      (pageChange)="pageChange.emit($event)"
      [pageCount]="searchItem.search.pageCount"
      [pageNum]="searchItem.search.pageNum"
      class="grow"
    ></cat-result-list-paginator>
    @if (hasDownloadBatchRole && vm.active) {
      <button (click)="onCheckAll()"
              [disabled]="vm.downloadInProgress"
              [title]="vm.label | transloco" mat-icon-button>
        <mat-icon [ngClass]="[vm.iconClass]">{{ vm.icon }}</mat-icon>
      </button>
    }
  </div>
}
